export function createPropsComparator<T extends object>(keys: Array<keyof T>) {
  return function arePropsEqual(prev: Readonly<T>, next: Readonly<T>): boolean {
    for (const key of keys) {
      const prevValue = prev[key];
      const nextValue = next[key];
      const isSame = Object.is(prevValue, nextValue);
      if (!isSame) {
        return false;
      }
    }
    return true;
  };
}

export function areStringArraysEqual(
  a?: readonly string[] | null,
  b?: readonly string[] | null
): boolean {
  const arrA = a ?? [];
  const arrB = b ?? [];
  if (arrA === arrB) {
    return true;
  }
  if (arrA.length !== arrB.length) {
    return false;
  }
  for (let i = 0; i < arrA.length; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }
  return true;
}
